import { DataRelationTypeEnum } from '../enums/data-relation-type.enum';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { LiteDataEntityPresenterModel } from './entity-presenter.model';
import { LiteFieldPresenterModel } from './field-presenter.model';

export class DataRelationPresenterModel {
  dataEntity: string;
  icon: IconModel;
  targetEntity: LiteDataEntityPresenterModel;
  targetField: LiteFieldPresenterModel;
  relationType: DataRelationTypeEnum;
  id?: string;
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  normalizedName?: string;
  specificationVersion: number;
}
